export const sessionsContainer = "swny8bh";
export const session = "s1dp6yak";
export const successIcon = "s9yggcd";
export const tickIcon = "t12xpyqj";
export const link = "le4cs1t";
export const button = "bqxw84";

require("./style.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./style.ts");